import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Route değişimlerinde sayfanın tepesine hızla scroll eder.
 * URL hash varsa hash davranışını bozmaz (hash'e scroll edilir).
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // Tarayıcı doğal hash-scroll'ünü koru.
      return;
    }
    // Tarayıcı-uyumlu instant scroll.
    try {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    } catch {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
}
